import { Image as AntImage } from 'antd';
import { ImageProps } from 'antd/lib/image';
import React from 'react';

import { ImageGroup } from './Image.Group';

export interface IImageProps extends ImageProps {}

type TImage = React.FC<IImageProps> & {
  Group: typeof ImageGroup;
};

/**
 * Image component
 */
export const Image: TImage = (props) => <AntImage {...props} />;

Image.Group = ImageGroup;
